/* eslint-disable no-param-reassign */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import attachCallbackToCalendlyEventScheduled from '@/services/vendors/calendly';
// initial state
const state = {
  assistantMessage: null,
  accountComponentType: null,
  accountComponentAction: null,
  amendmentComponentType: null,
  bankAccountModalShown: false,
  dynamicComponentType: null,
  crossSellComponentType: null,
  crossSellCancelAction: () => {},
  customMessage: [],
  saleReps: {
    '94cdca8d-891f-4b9a-81d3-9f06b318fc7d': 'https://calendly.com/elodie-assurup/15min-1',
    '8d14b920-bb99-4f37-99ac-c79136ea5e24': 'https://calendly.com/pauline-assurup/15min-1',
    'e43078cd-de37-4ad4-aa39-b3677b2c4fcb': 'https://calendly.com/audrey-louche-assurup/15min-1',
    '5c8ca07a-ff1f-4987-b153-cc48e03ecb65': 'https://calendly.com/audrey-assurup/15min-call',
    'dadf2505-7c8f-40c6-b539-9ffdb86fc2d0': 'https://calendly.com/jeremy_assurup/presentationassurup',
    '2eecc285-2fad-41ba-9aed-effcd8a77338': ' https://calendly.com/nolwenn-9/15min',
  },
  toast: {
    show: false,
    message: '',
  },
  extensionId: null,
  focusScreen: false,
  isToolBarMobileOpen: true,
  isToolBarOpen: true,
  loading: false,
  menuMobile: false,
  showFooter: false,
  showModal: false,
  showMenu: true,
};

// getters
const getters = {
  focusScreen: (state) => state.focusScreen,
  isToolBarMobileOpen: (state) => state.isToolBarMobileOpen,
  isToolBarOpen: (state) => state.isToolBarOpen,
  isMenuOpen: (state) => state.showMenu,
  loading: (state) => state.loading,
  menuMobile: (state) => state.menuMobile,
  showFooter: (state) => state.showFooter,
  showModal: (state) => state.showModal,
  bankAccountModalShown: (state) => state.bankAccountModalShown,
  amendmentComponentType: (state) => state.amendmentComponentType,
  crossSellComponentType: (state) => state.crossSellComponentType,
  dynamicComponentType: (state) => state.dynamicComponentType,
  crossSellCancelAction: (state) => state.crossSellCancelAction,

  accountComponentType: (state) => state.accountComponentType,
  accountComponentAction: (state) => state.accountComponentAction,

  extensionId: (state) => state.extensionId,
};

// actions
const actions = {
  setValue({ commit }, object) {
    commit('SET_VALUE', object);
  },
  openCalendly({ rootGetters, state }, callback) {
    const { email, lastName } = rootGetters['client/get'];
    const salerep = rootGetters['client/salerep'];
    const path = state.saleReps[salerep] || 'https://calendly.com/salesassurup/onvousaide';
    window.Calendly.showPopupWidget(`${path}?name=${lastName}&email=${email}`);
    attachCallbackToCalendlyEventScheduled(callback || Promise.resolve);
  },
  openToolBar({ commit }) {
    commit('OPEN_TOOLBAR');
  },
  setAssistantMessage({ commit }, message) {
    commit('SET_ASSISTANT_MESSAGE', message);
  },
  forceAssistantMessage({ commit }, message) {
    commit('FORCE_ASSISTANT_MESSAGE', message);
  },
  showToast({ commit }, object) {
    commit('SHOW_TOAST', object);
    return Promise.resolve();
  },
  showModal({ commit, dispatch }, value) {
    if (window.screen.width > 767) {
      if (value) {
        dispatch('intercom/hideLauncher', null, { root: true });
      } else {
        dispatch('intercom/showLauncher', null, { root: true });
      }
    }
    commit('SHOW_MODAL', value);
  },
  showModalPassword({ commit, dispatch }) {
    commit('SET_VALUE', { dynamicComponentType: 'password' });
    return dispatch('showModal', true);
  },
  showModalBankAccount({ commit, dispatch }) {
    commit('SET_VALUE', { dynamicComponentType: 'bank-account' });
    return dispatch('showModal', true);
  },
  showModalDeleteAccount({ commit, dispatch }) {
    commit('SET_VALUE', { dynamicComponentType: 'delete-account' });
    return dispatch('showModal', true);
  },
  showModalComplementaryInfo({ commit, dispatch }) {
    commit('SET_VALUE', { dynamicComponentType: 'complementary-information' });
    return dispatch('showModal', true);
  },
  showModalFeedback({ commit, dispatch }) {
    commit('SET_VALUE', { dynamicComponentType: 'feedback' });
    return dispatch('showModal', true);
  },
  showModalAmendment({ commit, dispatch }, { value, type }) {
    commit('SET_VALUE', { amendmentComponentType: type });
    commit('SET_VALUE', { dynamicComponentType: 'amendment' });
    return dispatch('showModal', value);
  },
  showModalAccount({ commit, dispatch }, { value, type }) {
    commit('SET_VALUE', { accountComponentType: type });
    commit('SET_VALUE', { dynamicComponentType: 'account' });
    return dispatch('showModal', value);
  },
  showModalCrossSell({ commit, dispatch }, { value, type, cancel }) {
    commit('SET_VALUE', { crossSellComponentType: type });
    commit('SET_VALUE', { dynamicComponentType: 'cross-sell' });
    commit('SET_VALUE', { crossSellCancelAction: cancel });
    return dispatch('showModal', value);
  },
  showModalSchedule({ commit, dispatch }, value) {
    commit('SET_VALUE', { dynamicComponentType: 'schedule' });
    return dispatch('showModal', value);
  },
  focusScreen({ commit, state }, value) {
    if (state.focusScreen !== value) {
      commit('FOCUS_SCREEN', value);
    }
  },
  showFooter({ commit }, value) {
    commit('SHOW_FOOTER', value);
  },
  showLoading({ commit }, value) {
    commit('SHOW_LOADER', value);
  },
};

// mutations
const mutations = {
  SET_VALUE(state, object) {
    const [key] = Object.keys(object);
    state[key] = object[key];
  },
  SET_ASSISTANT_MESSAGE(state, message) {
    Object.assign(state, { assistantMessage: message });
  },
  FORCE_ASSISTANT_MESSAGE(state, message) {
    Object.assign(state, { assistantMessage: true });
    Object.assign(state, { customMessage: message });
  },
  SHOW_MODAL(state, showModal) {
    const { classList } = document.body;
    if (showModal) {
      classList.add('modal-open');
    } else {
      classList.remove('modal-open');
    }
    state.showModal = showModal;
  },
  SHOW_TOAST(state, object) {
    state.toast = object;
  },
  SHOW_LOADER(state, value) {
    state.loading = value;
  },
  FOCUS_SCREEN(state, value) {
    state.focusScreen = value;
  },
  SHOW_FOOTER(state, value) {
    state.showFooter = value;
  },
  OPEN_TOOLBAR(state) {
    state.isToolBarOpen = !state.isToolBarOpen;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
